import React, { memo, useCallback, useState } from 'react';
import { Card, Tabs, TabPanel, Tab } from 'tea-component';
import classNames from 'classnames';
import Loading from '@gp/components/Loading';
// import Skeleton from '@gp/components/SkeletonAntd';
import NoData from '@gp/components/NoData';
import { isEqual } from 'lodash-es';
import './index.scss';

type TriggerViewCardPropsTypes = {
  className?: string;
  rootNodeClassName?: string;
  rootNodeStyle?: React.CSSProperties;
  bodyClassName?: string;
  style?: React.CSSProperties;
  title: any;
  loading: boolean;
  loadingType?: 'round' /* | 'skeleton' */;
  isNoData: boolean;
  noDataText?: string;
  tabs: Tab | any;
  defaultActiveId?: string;
};

const DEFAULT_PROPS: TriggerViewCardPropsTypes = {
  className: '',
  rootNodeClassName: '',
  rootNodeStyle: {},
  bodyClassName: '',
  style: {},
  title: null,
  loading: false,
  loadingType: 'round',
  isNoData: true,
  noDataText: 'No Data',
  tabs: [],
  defaultActiveId: undefined,
};

const TriggerViewCard = (props: TriggerViewCardPropsTypes) => {
  const {
    className,
    rootNodeClassName,
    rootNodeStyle,
    bodyClassName,
    style,
    title,
    loading,
    loadingType,
    isNoData,
    noDataText,
    tabs,
    defaultActiveId,
  } = props;

  const [activeId, setActiveId] = useState<string | undefined>(undefined);

  const getLoading = useCallback(() => {
    switch (loadingType) {
      case 'round':
        return <Loading loading style={{ height: 200 }} />;

      // case 'skeleton':
      //   return (<Skeleton paragraph={{ rows: 7 }} />);

      default:
        return <Loading loading style={{ height: 200 }} />;
    }
  }, [loadingType]);

  return (
    <Card
      className={classNames('dbg-trigger-view-card', rootNodeClassName)}
      style={rootNodeStyle}
    >
      <Card.Body
        className={classNames('dbg-trigger-view-card-body', className, {
          'is-nodata': isNoData,
        })}
        style={style}
        title={title}
      >
        {loading ? (
          getLoading()
        ) : isNoData ? (
          <NoData
            text={noDataText}
            height={200}
            constomStyle={{ fontSize: 14 }}
          />
        ) : (
          <Tabs
            animated={false}
            tabs={tabs}
            defaultActiveId={defaultActiveId}
            activeId={activeId}
            onActive={(
              tab: Tab | any,
              evt: React.SyntheticEvent<Element, Event>,
            ) => {
              const tabId = !tab?.component
                ? activeId || defaultActiveId
                : tab?.id;
              setActiveId(tabId);
            }}
          >
            {tabs?.map((item: any) => (
              <TabPanel key={item?.id} id={item?.id} className={bodyClassName}>
                {item?.component}
              </TabPanel>
            ))}
          </Tabs>
        )}
      </Card.Body>
    </Card>
  );
};

TriggerViewCard.defaultProps = DEFAULT_PROPS;

export default memo(TriggerViewCard, (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
});
